export default {
  host: {
    mdkguweb: `https://mdkeningau.sabah.gov.my/`,
    mdkgupay: `https://mdkgu.pbtpay.net/`,
    epayment: 'https://mdkgu.pbtpay.net',
    eservices: 'https://services.mdkgu.pbtpay.net/',
    EPBT3: 'https://data.mdkgu.sabahgov.net',
    EPBT3_middleware: 'https://data.mdkgu.sabahgov.net',
    SABAH_GOV_WEB: 'https://egjpkn.sabah.gov.my/SSONewLogin/index.asp'
  },
  AES_SECRET: 'ZN1MTXEvFw2sPKcuRjObBYBCenpEftAX',
  WORKER: 'https://mdkgu.pbtpay.net/api/v1',
  COUCHDB: 'https://mdkgu.pbtpay.net/database',
  withCredentials: false,
  withCredentialsWorker: false,
  council: 'mdkgu',
  publicMode: true
}
